import React, { useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageContainer from 'containers/PageContainer';
import { Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import VerifyView from 'views/VerifyView';
import { Auth } from 'lib/Amplify';
import { setAppBusy } from 'store/actions/system';
import { setEmailVerified } from 'store/actions/user';
import useMessages from 'hooks/useMessages';

const codeExpiredGetANewOneBelowMessage = 'Sorry that didn\'t work. Please check and try again. Code expired? Get a new one below.';

const VerifyContainer = ({ history }) => {
  const dispatch = useDispatch();
  const email = useSelector((state) => state.email);
  const emailVerified = useSelector((state) => state.emailVerified);
  const [error, setError] = useState();
  const {
    sendCodeSuccess, sendCodeFailure, genericFailureMessage, validateEmailSuccess, clearMessage,
  } = useMessages();

  if (!email) {
    return <Redirect to="/" />;
  }

  if (emailVerified) {
    return <Redirect to="/find_account" />;
  }

  const handleSubmit = (code) => {
    dispatch(setAppBusy(true));
    Auth.confirmSignUp(email, code)
      .then(() => {
        clearMessage();
        dispatch(setEmailVerified());
        validateEmailSuccess();
        history.push('/login');
      })
      .catch((err) => {
        switch (err.code) {
          case 'ExpiredCodeException':
          case 'CodeMismatchException':
            clearMessage();
            setError(codeExpiredGetANewOneBelowMessage);
            break;
          default:
            genericFailureMessage('Oops that didn\'t work.');
        }
      })
      .finally(() => dispatch(setAppBusy(false)));
  };

  const resendCode = () => {
    dispatch(setAppBusy(true));
    Auth.resendSignUp(email)
      .then(() => {
        sendCodeSuccess();
      })
      .catch(() => {
        sendCodeFailure(resendCode);
      })
      .finally(() => dispatch(setAppBusy(false)));
  };

  return (
    <PageContainer hasBack>
      <VerifyView
        email={email}
        error={error}
        onSubmit={handleSubmit}
        onResendClick={resendCode}
      />
    </PageContainer>
  );
};

VerifyContainer.displayName = 'VerifyContainer';

VerifyContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default VerifyContainer;
